import { render } from "./BtnClose.vue?vue&type=template&id=88478df8&scoped=true"
import script from "./BtnClose.vue?vue&type=script&lang=js"
export * from "./BtnClose.vue?vue&type=script&lang=js"

import "./BtnClose.vue?vue&type=style&index=0&id=88478df8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88478df8"]])

export default __exports__